import { render, staticRenderFns } from "./QuotationRequestView.vue?vue&type=template&id=32a88a42&scoped=true"
import script from "./QuotationRequestView.vue?vue&type=script&lang=js"
export * from "./QuotationRequestView.vue?vue&type=script&lang=js"
import style0 from "./QuotationRequestView.vue?vue&type=style&index=0&id=32a88a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a88a42",
  null
  
)

export default component.exports